import React, { useState, useEffect } from 'react'
import AInvbasicDetail from './AInvbasicDetail'
import { Button, CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle, Grid } from '@mui/material'
import { addInvoiceApi, getInvoiceNumberApi } from '../apiService'
import { globalGetService, globalPostService } from '../../../utils/globalApiServices'
import { checkApiStatus, normalizeTaxRate } from '../../../utils'
import { useSnackbar } from 'notistack'
import { PageLoader, titanAviationIntance, hanwahaInstance } from '../../../shared_elements'
import moment from 'moment'
import { useNavigate } from 'react-router'
import { setFileUploadDetails, setUploadFiles } from '../../../shared_elements/actions'
import { useDispatch, useSelector } from 'react-redux'
import { trackActivity } from '../../../utils/mixpanel'
import { getAdditionalTax, getTotalTax } from '..'
import { getInvoiceDialogWidthProps } from './AInvItems'

const AddAdhocInv = ({onToggleModal, modeType,leaseSlug, addEditInvoice, getResponseBack}) => {
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const { leaseBasicDetails } = useSelector((state) => state.leases);
  const [invoice, setInvoice] = useState({...addEditInvoice?.data, asset:leaseBasicDetails?.asset,});
  const { enqueueSnackbar } = useSnackbar();
  const [error, setError] = useState({});
  const [tableErrors, setTableErrors] = useState({});
  const [attachments, setAttachments] = useState([]);
  const [isLoading, setLoading] = useState(false);
  const [invoiceNumberLoading, setInvoiceNumberLoading] = useState(true);
  const [activeTaxList, setActiveTaxList] = useState([]);
  const [isQbEnabled, setIsQbEnabled] = useState(false);
  const showQbValidation = isQbEnabled && hanwahaInstance;

  useEffect(() => {
    globalGetService(getInvoiceNumberApi({ lease_slug: leaseSlug, asset_id: invoice?.asset?.id, asset_type: invoice?.asset?.asset_type, invoice_type: invoice?.invoice_type?.value, })).then((response) => {
      if (checkApiStatus(response)) {
        setInvoice((prev) => ({ ...prev, invoice_number: response?.data?.data?.invoice_number,  to:response?.data?.data?.lessee, from:response?.data?.data?.lessor }));
      }
      setInvoiceNumberLoading(false);
    });
  }, []);

	const onAddEditInvoice = () => {
		let validationInputs = {
			invoice_number: invoice?.invoice_number?.trim()?.length ? '' : 'Please enter Invoice Number',
			date: invoice?.date ? '' : 'Please enter Invoice Date',
			due_date: invoice?.due_date ? '' : 'Please enter Due Date',
			start_date: invoice?.start_date ? '' : 'Please enter Period Start Date',
			end_date: invoice?.end_date ? '' : 'Please enter Period End Date',
			currency: invoice?.currency ? '' : 'Please select Currency',
			bank: invoice?.bank?.id ? '' : 'Please select Bank',
			from: invoice?.from?.id ? '' : 'Please select From',
			to: invoice?.to?.id ? '' : 'Please select To'
		}

		const invoiceDate = moment(invoice?.date);
		const dueDate = moment(invoice?.due_date);
		const startDate = moment(invoice?.start_date);
		const endDate = moment(invoice?.end_date);
		const maxAllowedDate = moment(leaseBasicDetails?.end_date).add(3, 'months');

		if (invoice?.date && invoice?.due_date) {
			if (dueDate.isBefore(invoiceDate)) {
				validationInputs.due_date = "Due Date cannot be before Invoice Date";
			}
			if (invoiceDate.isAfter(dueDate)) {
				validationInputs.date = "Invoice Date cannot be after Due Date";
			}
			if (invoiceDate.isBefore(leaseBasicDetails?.start_date)) {
				validationInputs.date = "Invoice Date cannot be before Lease Start Date";
			}
			if (invoiceDate.isAfter(maxAllowedDate)) {
				validationInputs.date = "Invoice Date must be within 3 months after the Lease End Date.";
			}
			if (dueDate.isAfter(maxAllowedDate)) {
				validationInputs.due_date = "Due Date must be within 3 months after the Lease End Date.";
			}
			if (dueDate.isBefore(leaseBasicDetails?.start_date)) {
				validationInputs.due_date = "Due Date cannot be before Lease Start Date";
			}
			if (invoice?.due_date && !dueDate.isValid()) {
                validationInputs.due_date = "Please enter valid Due Date";
            }
            if (invoice?.date &&!invoiceDate.isValid()) {
                validationInputs.date = "Please enter valid Invoice Date";
            }
		}

		if (invoice?.start_date && invoice?.end_date) {
			if (endDate.isBefore(startDate)) {
				validationInputs.end_date = "Period End Date cannot be before Period Start Date";
			}
			if (startDate.isAfter(endDate)) {
				validationInputs.start_date = "Period Start Date cannot be after Period End Date";
			}
			if (startDate.isBefore(leaseBasicDetails?.start_date)) {
				validationInputs.start_date = "Period Start Date cannot be before Lease Start Date";
			}
			if (startDate.isAfter(leaseBasicDetails?.end_date)) {
				validationInputs.start_date = "Period Start Date cannot be after Lease End Date";
			}
			if (endDate.isAfter(leaseBasicDetails?.end_date)) {
				validationInputs.end_date = "Period End Date cannot be after Lease End Date";
			}
			if (endDate.isBefore(leaseBasicDetails?.start_date)) {
				validationInputs.end_date = "Period End Date cannot be before Lease Start Date";
			}
			if (invoice?.end_date && !endDate.isValid()) {
                validationInputs.end_date = "Please enter valid Period End Date";
            }
            if (invoice?.start_date &&!startDate.isValid()) {
                validationInputs.start_date = "Please enter valid Period Start Date";
            }
		}

		setError({ ...validationInputs });

		// ----------------Item Table Condition-----------
		let newErrors = {};
		if ((((invoice?.due_date && invoice?.date && invoice?.invoice_number && invoice?.currency && invoice?.bank && invoice?.from && invoice?.to &&  !dueDate.isBefore(invoiceDate))) && invoice?.invoice_items?.length === 0)) {
			enqueueSnackbar('Please add at least one Invoice Item', { variant: "error", anchorOrigin: { horizontal: "right", vertical: "top" }, });
			return
		}

		invoice.invoice_items.forEach((row, index) => {
				const errors = {};

				if (!row.invoice_item_name) {
					errors.invoice_item_name = "Please enter Invoice Item";
				}

				if (!row.description?.trim()) {
				errors.description = "Please enter Description";
				}

				if (row.sub_total === '' || row.sub_total === null || row.sub_total === undefined) {
					errors.sub_total = "Please enter Amount.";
				} else if (parseFloat(row.sub_total) <= 0) {
					errors.sub_total = "Please enter an Amount greater than 0.";
				}

				if (showQbValidation && !row.qb_product_and_service_id) {
					errors.qb_product_and_service_id = "Please select Product & Service";
				}

				if (showQbValidation && !row.qb_chart_of_account_id) {
					errors.qb_chart_of_account_id = "Please select Chart of Account";
				}

				if (showQbValidation && !row.qb_class_id) {
					errors.qb_class_id = "Please select Class";
				}

				if (showQbValidation && !row.qb_sub_class_id) {
					errors.qb_sub_class_id = "Please select Sub Class";
				}

				if (Object.keys(errors).length > 0) {
					newErrors[index] = errors;
				}
			});

			setTableErrors(newErrors)
		if (!Object.keys(validationInputs).every((k) => validationInputs[k] === '') || Object.keys(newErrors).length > 0) {
			trackActivity(`Item Added`, { page_title: `Add Adhoc Invoice`, error_msg: validationInputs, })
			return;
		}
		const normalizedItems = invoice?.invoice_items?.map(({ qb_product_and_service_id, qb_chart_of_account_id, qb_class_id, qb_sub_class_id, ...item }) => ({ ...item, tax_rate: normalizeTaxRate(item?.tax_rate), qb_product_and_service: qb_product_and_service_id || null, qb_chart_of_account: qb_chart_of_account_id || null, qb_class: qb_class_id || null, qb_sub_class: qb_sub_class_id || null }));
		let updatedInvoiceItems = getAdditionalTax(normalizedItems, activeTaxList )
		let tax_details =  getTotalTax(normalizedItems, activeTaxList)
		setLoading(true);
		globalPostService(addInvoiceApi(), {...invoice, tax_details:tax_details, invoice_items: updatedInvoiceItems, lease_slug: leaseSlug, asset: leaseBasicDetails?.asset, additional_taxes: activeTaxList, footer_note : invoice?.bank?.footer_note || null,})
			.then(async(response) => {
				if (checkApiStatus(response)) {
					if (attachments?.length) {
						dispatch(setUploadFiles({ modal:true,slug: response?.data?.data?.slug }));
					}
					setLoading(false);
					onToggleModal()
					trackActivity('Item Added', { page_title: `Add Adhoc Invoice`, success_msg: response?.data?.message, item_id: response?.data?.data?.id, payload: invoice, response: response?.data })
					navigate(`/invoices/view/${response?.data?.data?.slug}`,{ state: { from: 'viewFromLease' } })
					getResponseBack();
					enqueueSnackbar(response?.data?.message, { variant: "success", anchorOrigin: { horizontal: "right", vertical: "top" } });
				} else {
					setLoading(false);
					enqueueSnackbar(response?.data?.message, { variant: "error", anchorOrigin: { horizontal: "right", vertical: "top" } });
					trackActivity('Item Added', { page_title: `Add Adhoc Invoice`, error_msg: response?.data?.message, item_id: null, payload: invoice, response: response?.data })
				}
			})
	};

	const onFieldChange = (keyParam, value, invoiceItem, itemIndex) => {
        if (invoiceItem) {
            if (keyParam === "sub_total" || keyParam === "tax_rate") {
                setInvoice((prev) => {
                    let taxAmount = 0;
                    let subTotal = 0;
					const existingTaxRate = parseFloat(prev.invoice_items[itemIndex].tax_rate) || 0;
                    if (keyParam === "sub_total") {
                        subTotal = parseFloat(value) || 0;
                        if (existingTaxRate) {
                            taxAmount = subTotal * (existingTaxRate / 100);
                        }
                    } else {
                        subTotal = parseFloat(prev.invoice_items[itemIndex].sub_total) || 0;
                        if (value) {
                            taxAmount = subTotal * (parseFloat(value) / 100);
                        }
                    }

                    const subAmountTotal = subTotal + taxAmount;

                    return {
                        ...prev,
                        invoice_items: prev.invoice_items.map((item, index) =>
                            index !== itemIndex
                                ? item
                                : {
                                    ...item,
                                    [keyParam]: value,
                                    tax_amount: taxAmount.toFixed(4),
                                    sub_amount_total: subAmountTotal.toFixed(4),
                                }
                        ),
                    };
                });
            } else {
                setInvoice((prev) => ({
                    ...prev,
                    invoice_items: prev.invoice_items.map((item, index) =>
                        index !== itemIndex ? item : { ...item, [keyParam]: value, ...(keyParam === 'qb_class_id' ? { qb_sub_class_id: null } : {}) }
                    ),
                }));
            }
        } else {
            setInvoice((prev) => ({ ...prev, [keyParam]: value }));
        }
    };
	
	const onAddRemoveInvoiceItem = (opsType, itemIndex) => {
		if(opsType === 'add'){
			setInvoice({
				...invoice,
				invoice_items:[...invoice.invoice_items, {invoice_item_name:'',description:'',tax_rate:0, tax_amount:'', sub_total:0}]
			})
		}else{
			setInvoice({
				...invoice,
				invoice_items: invoice.invoice_items.filter((item, index) => itemIndex !== index)
			})
		}
	}

	const onRestErrorKey = (keyParam) => {
		setError({ ...error, [keyParam]: '' })
	}
	
	const handleFileChange = (files) => {
			setAttachments(files);
			dispatch(setFileUploadDetails({ attachments: files }))
		};

	const resetTableError = (rowIndex, fieldName) => {
		setTableErrors((prevErrors) => {
			const rowErrors = { ...prevErrors[rowIndex] };
			delete rowErrors[fieldName];

			const updatedErrors = { ...prevErrors };
			if (Object.keys(rowErrors).length === 0) {
				delete updatedErrors[rowIndex];
			} else {
				updatedErrors[rowIndex] = rowErrors;
			}

			return updatedErrors;
		});
	};
	const handleItemClicked = (page_type) => {
		trackActivity('Item Clicked', { page_title: `Add Adhoc Invoice`, page_type: page_type, })
	}
	return (
		<>
			<Dialog aria-labelledby="customized-dialog-title" className='add-lease-dialog' {...getInvoiceDialogWidthProps({ invoice, type: 'adhocInvoice', activeTaxList, showQbFields: showQbValidation })} open={true} scroll='paper'>
				<DialogTitle sx={{ m: 0, p: 2, pl:3 }} className='dialog-header' id="customized-dialog-title">
					Add Adhoc Invoice 
				</DialogTitle>
				<DialogContent dividers>
					<Grid container spacing={2}>
						<AInvbasicDetail addEditInvoice={addEditInvoice} type={'adhocInvoice'} modeType={modeType} onFieldChange={onFieldChange} onRestErrorKey={onRestErrorKey} invoice={invoice} error={error} onAddRemoveInvoiceItem={onAddRemoveInvoiceItem} handleFileChange={handleFileChange} tableErrors={tableErrors} resetTableError={resetTableError} leaseSlug={leaseSlug} onActiveTaxLoad={setActiveTaxList} invoiceNumberLoading={invoiceNumberLoading} onQbStatusLoad={setIsQbEnabled}/>
					</Grid>
				</DialogContent>
				<DialogActions sx={{ marginRight: "15px" }}>
					<Button className='cancel-btn' variant='outlined' size='small' disabled={isLoading} onClick={() => { onToggleModal(); handleItemClicked('Cancel Button') }} > Cancel </Button>
					<Button variant='contained' className='btn-primary' size='small' onClick={() => { handleItemClicked('Save Button'); onAddEditInvoice(); }}>
						{isLoading ? <CircularProgress color='inherit' size={25} /> : "Save"}
					</Button>
				</DialogActions>
			</Dialog>
			{(isLoading || invoiceNumberLoading) ? <PageLoader /> : null}
		</>
	)
}

export default AddAdhocInv
